import { gql } from "@apollo/client";

export const QUIZ_FIELDS = gql`
  fragment QUIZ_FIELDS on quiz {
    id
    title
    type
  }
`;
